import { combineReducers } from 'redux';

import list from './List/reducer';
import view from './View/reducer';

const donationsReducer = combineReducers({
  list,
  view,
});

export default donationsReducer;
